export default __webpack_public_path__ + "static/forces-7ca5fdee80c3c75ae9c5b31d91011344.png";